import styled from 'styled-components';
import { Visibility } from 'types';

export const VisibilityWrapper = styled.div<Visibility>`
    visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
    height: 100%;
    width: 100%;
`;
